import React, { useState, useEffect, useMemo } from "react";
import UploadFile from "./../common/UploadFile";
import TableWithPagination from "./../common/TableWithPagination"; 
import ConfirmDialog from "./../common/ConfirmDialog";
import { useApi } from "./../../hooks/useApi";
import { API_URLS  } from "../../api/apiUrls";
import { toast } from 'react-toastify';

// Función para formatear fechas
const formatDate = (date) => {
  return new Date(date).toLocaleDateString("es-MX");
};

const Archivos = () => {
  const { get,  delete: del, put } = useApi();
  const [showUpload, setShowUpload] = useState(false);
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [catalogoProcesos, setCatalogoProcesos] = useState([]);
  const [cadenaFiltro, setCadenaFiltro] = useState("");

  // dialogo para confirmar
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [fileToProcess, setFileToProcess] = useState(null);
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const [fileToDelete, setFileToDelete] = useState(null);


  // Columnas de la tabla
  const columnsResults = [
    { header: "Proceso", accessor: "proceso" },
    { header: "Archivo", accessor: "nombre" },
    { header: "Usuario", accessor: "usuarioId" },
    { header: "Fecha", accessor: "fecha" }
  ];

  // Cargar procesos y archivos
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        // Traer procesos
        const procesos = await get("listaProcesos");
        setCatalogoProcesos(procesos);

        // Traer archivos
        const response = await get("ListFiles");

        // Filtrar solo archivos con procesos válidos
        const validIds = procesos.map(p => p.id);
        //const filtered = response.filter(f => validIds.includes(f.cadenaId));

        // Mapear archivos para la tabla
        const mappedFiles = response.map(f => {
          const proceso = procesos.find(p => p.id === f.cadenaId);
          return {
            id: f.id,
            nombre: f.nombre,
            usuarioId: f.usuarioId || "N/A",
            fecha: f.createdAt ? formatDate(f.createdAt) : "",
            url: f.url,
            proceso: proceso ? proceso.procesoNombre : "Desconocido",
            cadenaId: f.cadenaId
          };
        });

        setFiles(mappedFiles);
      } catch (error) {
        console.error("Error al cargar datos:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [get]);

  // Filtrar archivos según el select
  const archivosFiltrados = useMemo(() => {
    if (!cadenaFiltro) return files;
    return files.filter(f => String(f.cadenaId) === String(cadenaFiltro));
  }, [files, cadenaFiltro]);

  // Método para cargar archivos
const loadFiles = async () => {
  setLoading(true);
  try {
    const response = await get("ListFiles");

    // Filtrar solo archivos que tengan un proceso válido
    const validIds = catalogoProcesos.map(p => p.id);
    const filtered = response.filter(f => validIds.includes(f.cadenaId));

    const mappedFiles = filtered.map(f => {
      const proceso = catalogoProcesos.find(p => p.id === f.cadenaId);
      return {
        id: f.id,
        nombre: f.nombre,
        usuarioId: f.usuarioId || "N/A",
        fecha: f.createdAt ? formatDate(f.createdAt) : "",
        url: f.url,
        proceso: proceso ? proceso.procesoNombre : "Desconocido",
        cadenaId: f.cadenaId
      };
    });

    setFiles(mappedFiles);
  } catch (error) {
    console.error(error);
  } finally {
    setLoading(false);
  }
};

const handleDeleteClick = (row) => {
  setFileToDelete(row);
  setIsDeleteDialogOpen(true);
};

const confirmarDelete = async () => {
  if (!fileToDelete) return;
  try {
    await del('deleteFile', { urlParams: { id: fileToDelete.id } });
    loadFiles();
  } catch (error) {
    console.error("Error al eliminar archivo", error);
    alert("No se pudo eliminar el archivo.");
  } finally {
    setIsDeleteDialogOpen(false);
    setFileToDelete(null);
  }
};

const cancelarDelete = () => {
  setIsDeleteDialogOpen(false);
  setFileToDelete(null);
};


/**
const deleteFile = async (row) => {
  const id = row.id
  
  if (!window.confirm("¿Seguro que quieres eliminar este archivo?")) return;

  try {
    await del('deleteFile', { urlParams: { id } }); 
    loadFiles();
  } catch (error) {
    console.error("Error al eliminar archivo", error);
    alert("No se pudo eliminar el archivo.");
  }
}; */

 const handleCheckboxClick = (row) => {
    setFileToProcess(row);
    setIsDialogOpen(true);
  };

 const confirmarProcesar = async () => {
  console.log("Procesando archivo:", fileToProcess.id);
  var id = fileToProcess.id;
    if (!fileToProcess) return;
    try {
      // segundo parametro es null porque el endpoint no requiere body
      
      await put('FileProcesa', null, { urlParams: { id: fileToProcess.id } });
      toast.success("Archivo enviado a proceso correctamente");
      loadFiles();
    } catch (err) {
      console.error("Error al procesar archivo:", err);
      toast.error("Hubo un error al procesar el archivo");
    } finally {
      setIsDialogOpen(false);
      setFileToProcess(null);
    }
  };

  const cancelarProcesar = () => {
  // cerrar y desmarcar checkbox
  setIsDialogOpen(false);
  setFileToProcess(null);
};


  return (
    <div className="p-4">
      {/* Header */}
      <div className="flex justify-between items-center pb-2">
        <h1 className="text-xl font-bold">Carga manual de archivos</h1>

        <div className="flex items-center gap-2">
       <select
          value={cadenaFiltro}
          onChange={(e) => setCadenaFiltro(e.target.value)}
          className="border rounded p-2"
        >
          <option value="">-- Todos los procesos --</option>
          {files
            .reduce((acc, f) => {
              if (!acc.some(p => p.id === f.cadenaId)) {
                acc.push({ id: f.cadenaId, procesoNombre: f.proceso });
              }
              return acc;
            }, [])
            .map((p) => (
              <option key={p.id} value={p.id}>
                {p.procesoNombre}
              </option>
            ))}
        </select>
          {!showUpload && (
            <button
              onClick={() => setShowUpload(true)}
              className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
            >
              Cargar nuevo
            </button>
          )}
        </div>
      </div>

      

      {/* Tabla de archivos */}
      {!showUpload && (
        <div className="bg-white shadow-lg rounded-lg overflow-hidden">
          <div className="p-4">
            <TableWithPagination
              columns={columnsResults}
              data={archivosFiltrados}
              showView={false}
              showEdit={false}
              showDelete={true}
              loading={loading}
              onDelete={handleDeleteClick}
              renderExtraActions={(row) => (
                <span title="Enviar a proceso" className="flex items-center gap-1 px-1.5 py-0.5 border rounded text-green-700 bg-gray-100 hover:bg-gray-200 text-xs">
                  <input
                    type="checkbox"
                    checked={fileToProcess?.id === row.id} 
                    onChange={() => handleCheckboxClick(row)}
                  />
                </span>
              )}
            />
          </div>
        </div>
      )}

      {/* Componente de carga */}
      {showUpload && (
        <div className="bg-white shadow-lg rounded-lg overflow-hidden w-full">
          <div className="p-4 border-b w-full">
            <UploadFile
              uploadUrl="uploadFile"
              onCancel={() => setShowUpload(false)}
              onUploaded={() => {
                // recarga la tabla
                setShowUpload(false);
                loadFiles();
              }}
              cadenas={catalogoProcesos}
            />
          </div>
        </div>
      )}
      <ConfirmDialog
        isOpen={isDialogOpen}
        onClose={cancelarProcesar}
        onConfirm={confirmarProcesar}
        title="Enviar a proceso"
        description="¿Confirma que desea enviar este archivo a procesar?"
      />

      <ConfirmDialog
        isOpen={isDeleteDialogOpen}
        onClose={cancelarDelete}
        onConfirm={confirmarDelete}
        title="Eliminar archivo"
        description="¿Estás seguro que deseas eliminar este archivo permanentemente?"
      />

    </div>
  );
};

export default Archivos;
